module.exports = __webpack_public_path__ + "img/image_027.896ece6a.jpg";